import { negate, pickBy } from 'lodash/fp';

// Use pickBy with negate instead of omitBy because pick is way faster than omit
export const omitFalsyExceptZeroAndFalse = pickBy(
  negate((x) => x == null || x === '' || Number.isNaN(x)),
);
